export const convertLanguageForApi = (lang) => {
    const languagesMap = {
        es: 'lg-spa',
        eu: 'lg-eus',
    };

    return languagesMap[lang] || lang;
};
